<template>
  <section class="section--benefits">
    <div class="section__container">
      <!-- ROW 1 -->
      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="6" md="6" lg="4" xl="4">
          <keep-alive>
            <v-img
              :src="
                require('@/assets/img/global-innovators.svg')
              "
              eager
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col
          class="section__col info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms700">
              Work with Global Innovators
            </p>
            <p class="section__description m500">
              At DIGU, you'll collaborate with some of the world’s most forward-thinking companies. It’s your chance to work on exciting products, explore cutting-edge technologies, and gain real exposure to global standards in software development, design, QA, and project management.
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Row 2 -->
      <v-row class="section__row">
        <v-col
          class="section__col order-last order-sm-first info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms700">
              Competitive Pay, 
                Elevated Living
            </p>
            <p class="section__description m500">
              We recognize your talent and reward it. Our professionals earn industry-leading salaries that improve their quality of life—without having to leave Nepal. You can grow your career and support your lifestyle at the same time.
            </p>
          </div>
        </v-col>
        <v-col class="section__col">
          <keep-alive>
            <v-img
              :src="
                require('@/assets/img/competitive-pay.svg')
              "
              eager
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
      </v-row>

      <!-- Row 3 -->
      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="6" md="6" lg="4" xl="4">
          <keep-alive>
            <v-img
              :src="
                require('@/assets/img/work-place-that-works.svg')
              "
              eager
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col
          class="section__col info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms700">
              A Workspace 
              That Works for You            </p>
            <p class="section__description m500">
              Our secure, 24/5 facility is designed for productivity and balance—with high-speed internet, ergonomic workstations, stocked snacks, and dedicated spaces to relax and recharge.
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Row 4 -->
      <v-row class="section__row">
        <v-col
          class="section__col order-last order-sm-first info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms700">
              Grow Your Career, Your Way
            </p>
            <p class="section__description m500">
              We invest in your development through tailored training, upskilling programs, and real-world experience with global clients. DIGU is where ambition meets opportunity—so you can grow, lead, and thrive.
            </p>
          </div>
        </v-col>
        <v-col class="section__col">
          <v-img
            :src="
              require('@/assets/img/grow-your-carrier.svg')
            "
            eager
            class="section__img"
          ></v-img>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BenefitsSection',
};
</script>

<style scoped>
.section--benefits {
  /* background-color: var(--secondary-color-lighten); */
  padding-block: 4rem;
}

@media only screen and (min-width: 700px) {
  .section--benefits {
    padding-block: 2rem;
  }
}

.section__header {
  margin-bottom: 3rem;
}

.section__subtitle {
  font-size: 1.25rem;
  color: var(--accent-red);
  text-align: left;
}

@media only screen and (min-width: 1200px) {
  .section__subtitle {
    font-size: 1.5rem;
  }
}

@media only screen and (min-width: 1200px) {
  .section__subtitle {
    font-size: 1.5rem;
  }
}

.section__title {
  line-height: 150% !important;
  font-size: 1.25rem !important;
  text-align: left;
}

@media only screen and (min-width: 960px) {
  .section__title {
    font-size: 2rem !important;
  }
}

.section__row {
  margin-bottom: 3rem;
}

@media only screen and (min-width: 1200px) {
  .section__row {
    margin-block: 4rem;
  }
}

.section__col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section__img {
  height: 250px;
  width: 100%;
}

@media only screen and (min-width: 1280px) {
  .section__img {
    max-width: 35rem;
    aspect-ratio: 4/3;
  }
}

.section__title-2 {
  text-align: left;
  line-height: 120%;
}

@media only screen and (min-width: 1200px) {
  .section__title-2 {
    margin-bottom: 1rem;
  }
}

.col__info {
  text-align: left;
}

@media only screen and (min-width: 1280px) {
  .col__info {
    text-align: left;
    width: 80%;
  }
}

@media only screen and (min-width: 1280px) {
  .info__col:nth-child(odd) {
    justify-content: flex-start;
  }

  .info__col:nth-child(even) {
    justify-content: flex-end;
  }
}
</style>
